import { useCallback, useState } from "react"

import { ResourceDetailsDialogParams } from "../../../../dialogs/resourceDetailsDialog/ResourceDetailsDialog"

export const useResourceDetailsDialog = () => {
    const [resourceDetails, setResource] = useState<ResourceDetailsDialogParams | null>(null)

    const openResourceDetailsDialog = useCallback((res: ResourceDetailsDialogParams) => setResource(res), [])
    const closeResourceDetailsDialog = useCallback(() => setResource(null), [])

    return { resourceDetails, openResourceDetailsDialog, closeResourceDetailsDialog }
}
